import { approveCreditApplicaton } from 'common/api/creditApplications';
import alerts from 'common/modules/alerts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import {
    APPROVE_CREDIT,
    APPROVE_CREDIT_FAILURE,
    APPROVE_CREDIT_SUCCESS,
} from '../actionTypes';
import { creditFileActions } from '../reducer';

export default (id, callback) => (dispatch) => {
    dispatch(creditFileActions[APPROVE_CREDIT]());

    approveCreditApplicaton(id)
        .then(() => {
            dispatch(creditFileActions[APPROVE_CREDIT_SUCCESS]());
            if (callback) callback();
            dispatch(alerts.actions.close());
        })
        .catch((error) => {
            dispatch(
                creditFileActions[APPROVE_CREDIT_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
